var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1_2763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.5111 15.2513L53.8113 15.4247C56.4051 16.9221 58.5679 18.1707 60.1516 19.3928C61.8233 20.6828 63.15 22.1635 63.7057 24.2374C64.2614 26.3114 63.8528 28.257 63.0501 30.21C62.493 31.5655 61.6737 33.0888 60.6866 34.8264L58.5689 33.5677L58.5416 33.5517L35.4573 20.2239L33.2984 18.9516C34.2987 17.2479 35.2 15.7928 36.0873 14.643C37.3773 12.9714 38.858 11.6446 40.9319 11.0889C43.0058 10.5332 44.9515 10.9419 46.9045 11.7446C48.7547 12.505 50.9175 13.7538 53.5111 15.2513Z",
    fill: "currentColor",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7937 23.2791L19.2004 43.3588C18.2078 45.0748 17.423 46.4317 17.1322 47.975C16.8414 49.5184 17.0787 51.0678 17.3788 53.0274L17.4596 53.5571C18.0136 57.1949 18.4702 60.1935 19.1589 62.4673C19.8791 64.8454 20.9863 66.9038 23.1638 68.161C25.3414 69.4183 27.6776 69.3479 30.0973 68.7826C32.4108 68.2421 35.2359 67.1382 38.6634 65.7991L39.1625 65.6042C41.0096 64.8843 42.4701 64.3151 43.6613 63.2916C44.8525 62.2681 45.6351 60.91 46.6249 59.1923L58.1907 39.1594L56.0279 37.8739L32.9281 24.5372L30.7937 23.2791Z",
    fill: "currentColor",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4311 35.2562L60.8695 35.5167L61.1213 35.0734C62.1091 33.3348 62.9423 31.7875 63.5126 30.4C64.3364 28.3956 64.7841 26.3302 64.1887 24.108C63.5933 21.8858 62.1728 20.321 60.4571 18.997C58.8469 17.7544 56.6604 16.4921 54.0899 15.0081L54.0613 14.9917L53.7611 14.8183L53.7327 14.8019C51.1623 13.3178 48.9758 12.0553 47.0945 11.2821C45.0901 10.4583 43.0247 10.0105 40.8025 10.606C38.5803 11.2014 37.0155 12.6219 35.6915 14.3375C34.7832 15.5145 33.8683 16.9935 32.8673 18.6984L32.6145 19.1289L33.0446 19.3823L35.2034 20.6547L35.2034 20.6547L35.2073 20.6569L58.2888 33.9831L58.2916 33.9847L58.3134 33.9975L58.3162 33.9991L60.4311 35.2562ZM31.0476 22.8484L30.6129 22.5922L30.3607 23.0291L18.7676 43.1085L18.7674 43.1088L18.74 43.1563C17.7697 44.8336 16.9475 46.2549 16.6408 47.8825C16.3342 49.51 16.5828 51.1331 16.8762 53.0485L16.8845 53.1029L16.8845 53.1031L16.9653 53.6323L16.9654 53.6325L16.971 53.6693C17.5203 57.2769 17.9813 60.3041 18.6803 62.6123C19.4172 65.0452 20.578 67.2454 22.9138 68.5941C25.2497 69.9427 27.7356 69.8479 30.211 69.2695C32.5595 68.7208 35.4116 67.6064 38.8106 66.2783L38.8451 66.2648L38.8453 66.2648L39.3441 66.0701L39.3443 66.07L39.3955 66.0501C41.201 65.3464 42.731 64.7502 43.9871 63.6709C45.2433 62.5915 46.0631 61.1688 47.0306 59.4898L47.0579 59.4423L47.0581 59.442L58.6237 39.4094L58.8706 38.9819L58.4462 38.7296L56.2833 37.4441L56.2833 37.444L56.2779 37.4409L33.182 24.1065L33.1781 24.1042L31.0476 22.8484Z",
    stroke: "url(#paint0_linear_1_2763)",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_2763",
    x: -7.99902,
    y: -14.1672,
    width: 96.9609,
    height: 108.338,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_2763"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_2763",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2763",
    x1: 17,
    y1: 10.833,
    x2: 74.0086,
    y2: 56.6778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c960655646eecf4c677efca799fedb77.svg";
export { ForwardRef as ReactComponent };